var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextStrike = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 10.5C5 11.8807 6.11929 13 7.5 13H8.5C9.88071 13 11 11.8807 11 10.5C11 9.59736 10.5408 8.80127 9.84683 8.33333M11 5.5C11 4.11929 9.88071 3 8.5 3H7.5C6.11929 3 5 4.11929 5 5.5C5 6.40264 5.45924 7.19873 6.15317 7.66667",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 8H13",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextStrike);
export default ForwardRef;